/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var Backbone = require('backbone');
var NProgress = require('nprogress');

var NavUtils = require('psa-core/util/nav');
var Radio = require('backbone.radio');

var Scaffold = require('common/layout/Scaffold');
var userHasRole = require('common/util/userHasRole');
var SecComplianceRegistrationSearchView = require('../views/SecComplianceRegistrationSearchView');
var GetAllUserComplianceRegistrations = require('../services/GetAllUserComplianceRegistrations');
var GetAllComplianceRegistrationLookups = require('../../compliance-registration-form/services/GetAllComplianceRegistrationLookups');

module.exports = function() {
  var isSCUser = userHasRole('SC - Compliance Registration Admin');
  if (isSCUser) {
    NProgress.start();
    NProgress.set(0.6);
    $.when(GetAllUserComplianceRegistrations(), GetAllComplianceRegistrationLookups())
      .done(function(complianceRegistrations, complianceLookups) {
        Scaffold.content.show(
          new SecComplianceRegistrationSearchView({
            model: new Backbone.Model({
              complianceRegistrations: complianceRegistrations,
              professionalTypes: complianceLookups.professionalTypes
            })
          })
        );
        NavUtils.navigate('sec/compliance-registration-search');
        NProgress.done();
      })
      .fail(function() {
        NProgress.done();
      });
  } else {
    Radio.channel('navigate').trigger('show:int:application-selection');
    NavUtils.navigate('#int/applications');
  }
};
